<template>
  <v-btn
    v-if="show"
    v-bind="$attrs"
    :color="url ? 'green' : 'red' "
    dark
    :loading="loading"
    @click="clickHandler"
  >
    {{ label }}
  </v-btn>
</template>

<script>
import userAPI from '@/api/user';

export default {

  name: 'TelegramButton',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    loading: false,
    checkActivateTelegram: null,
  }),

  computed: {
    label() {
      let text = 'Подождите...';

      if (this.loading) {
        return text;
      }
      if (this.url) {
        text = 'Подключить telegram бота';
      } else {
        text = 'Отключить telegram бота';
      }

      return text;
    },
  },

  methods: {
    clickHandler() {
      if (this.url) {
        this.enableTelegram();
      } else {
        this.resetTelegram();
      }
    },

    resetTelegram() {
      this.loading = true;
      userAPI.resetTelegram()
        .then((response) => {
          if (response.data.success) {
            this.$emit('reload');
            this.loading = false;
          }
        })
        .catch((err) => console.log(err));
    },

    enableTelegram() {
      this.loading = true;
      window.open(this.url, '_blank');

      this.checkActivateTelegram = setInterval(() => {
        userAPI.telegramCheck()
          .then((response) => {
            if (response.data.is_authorized) {
              clearInterval(this.checkActivateTelegram);
              this.$emit('reload');
              this.loading = false;
            }
          })
          .catch((err) => console.log(err));
      }, 5000);
    },
  },
};
</script>
